import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const Container = styled.p`
  background: white;
  padding: 12px 16px;

  ${fromMd} {
    padding: 2rem 0 1rem;
  }
`
